import { useMemo } from "react"
import { useAuth } from "@/components/auth-provider"
import { hasFeature, minPlanFor, planMeets } from "@/config/entitlements"

export function useEntitlements() {
  const { user } = useAuth()

  return useMemo(
    () => ({
      user,
      plan: user?.effective_plan || user?.subscription_plan || "solo",
      addons: user?.addon_ids || [],
      features: user?.features || [],
      hasFeature: (f) => hasFeature(user, f),
      minPlanFor,
      planMeets: (required) => planMeets(required, user?.effective_plan || "solo"),
      isTrialing: user?.subscription_status === "trialing" && Boolean(user?.trial_ends_at),
    }),
    [user]
  )
}
